import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-intro-delay"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "bg-rose-800 text-white text-xs mx-auto absolute bottom-2 px-1 rounded-lg" }
const _hoisted_4 = { class: "text-xs font-semibold" }
const _hoisted_5 = { class: "absolute bg-white border-2 border-b-4 border-black -bottom-20 left-10 w-32 px-2 py-2 rounded-lg z-30" }
const _hoisted_6 = { class: "flex gap-2 items-stretch" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-left flex flex-col justify-between" }
const _hoisted_9 = { class: "font-bold leading-none" }
const _hoisted_10 = { class: "text-xs font-semibold text-gray-500" }
const _hoisted_11 = { class: "text-xs font-semibold text-gray-500" }
const _hoisted_12 = { class: "text-xs font-semibold text-gray-500" }
const _hoisted_13 = { class: "text-xs font-semibold text-gray-500 absolute bottom-2 right-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: "absolute h-16 text-center rounded-md py-2 px-2",
    style: _normalizeStyle('width: 20%; left:' + ($props.left - 10) + '%; top:' + $props.top+'%'),
    onMouseover: _cache[0] || (_cache[0] = $event => ($data.showCard = true)),
    onMouseleave: _cache[1] || (_cache[1] = $event => ($data.showCard = false)),
    "data-intro": "slide-in-bottom",
    "data-intro-delay": 100 * Math.random()
  }, [
    _createElementVNode("img", {
      src: $props.player.image,
      alt: "",
      class: "h-12 mx-auto object-contain w-full"
    }, null, 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_3, _toDisplayString($props.player.number), 1 /* TEXT */),
    _createElementVNode("h4", _hoisted_4, _toDisplayString($props.player.nickname), 1 /* TEXT */),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("img", {
          src: $props.player.image,
          alt: "",
          class: "mx-auto object-cover w-1/3 h-full hidden"
        }, null, 8 /* PROPS */, _hoisted_7),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h3", _hoisted_9, _toDisplayString($props.player.name), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_10, _toDisplayString($props.player.position), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_11, _toDisplayString($props.player.country), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_12, _toDisplayString($props.player.dob), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_13, _toDisplayString($props.player.number), 1 /* TEXT */)
        ])
      ])
    ], 512 /* NEED_PATCH */), [
      [_vShow, $data.showCard]
    ])
  ], 44 /* STYLE, PROPS, NEED_HYDRATION */, _hoisted_1))
}